import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SwiperModule } from 'swiper/angular';
import { RouterModule } from '@angular/router';
import { HeroComponent } from './components/hero/hero.component';
import { ProgramsComponent } from './components/programs/programs.component';
import { StatsComponent, ThousandSeparatorPipe } from './components/stats/stats.component';
import { DpAppsComponent } from './components/dp-apps/dp-apps.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { PartnersComponent } from './components/partners/partners.component';
// import { WhatWeOfferPageComponent } from './pages/what-we-offer-page/what-we-offer-page.component';
// import { PrimarySecondaryEducationPageComponent } from './pages/primary-secondary-education-page/primary-secondary-education-page.component';
// import { PreSchoolPageComponent } from './pages/pre-school-page/pre-school-page.component';
// import { ResourcesPageComponent } from './pages/resources-page/resources-page.component';
// import { ContactPageComponent } from './pages/contact-page/contact-page.component';
// import { LeadershipPageComponent } from './pages/leadership-page/leadership-page.component';
// import { OurTeamPageComponent } from './pages/our-team-page/our-team-page.component';
// import { ContentSpecialistsPageComponent } from './pages/content-specialists-page/content-specialists-page.component';
// import { OurPartnersPageComponent } from './pages/our-partners-page/our-partners-page.component';
// import { GalleryPageComponent } from './pages/gallery-page/gallery-page.component';
// import { HelpCenterPageComponent } from './pages/help-center-page/help-center-page.component';
// import { FaqPageComponent } from './pages/faq-page/faq-page.component';
// import { CareersPageComponent } from './pages/careers-page/careers-page.component';
// import { AboutUsPageComponent } from './pages/about-us-page/about-us-page.component';
// import { SecondaryNavComponent } from './components/secondary-nav/secondary-nav.component';
import { LightboxModule } from 'ngx-lightbox';
// import { ImpactPageComponent } from './pages/impact-page/impact-page.component';
// import { FormModalComponent } from './components/form-modal/form-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { InformationTechnologyPageComponent } from './pages/information-technology-page/information-technology-page.component';
// import { TvetEducationPageComponent } from './pages/tvet-education-page/tvet-education-page.component';
// import { LanguagesPageComponent } from './pages/languages-page/languages-page.component';
// import { BuddhistStudiesPageComponent } from './pages/buddhist-studies-page/buddhist-studies-page.component';
// import { ComputerProgrammingPageComponent } from './pages/computer-programming-page/computer-programming-page.component';
// import { OlympiadPageComponent } from './pages/olympiad-page/olympiad-page.component';
// import { EconomicsPageComponent } from './pages/economics-page/economics-page.component';
// import { HealthPageComponent } from './pages/health-page/health-page.component';
// import { LifeSkillsPageComponent } from './pages/life-skills-page/life-skills-page.component';
import { ComingSoonPageComponent } from './pages/coming-soon-page/coming-soon-page.component';
import { BrandSliderComponent } from './components/brand-slider/brand-slider.component';
// import { AlbumPageComponent } from './pages/album-page/album-page.component';
// import { TvetCoursesPageComponent } from './pages/tvet-courses-page/tvet-courses-page.component';
import { CoreModule } from '../core/core.module';
import { ScholarshipComponent } from './components/scholarship/scholarship.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CookieComponent } from './pages/cookie/cookie.component';

@NgModule({
  declarations: [
    BrandSliderComponent,
    HomePageComponent,
    HeroComponent,
    ProgramsComponent,
    StatsComponent,
    DpAppsComponent,
    TestimonialsComponent,
    PartnersComponent,
    // WhatWeOfferPageComponent,
    // PrimarySecondaryEducationPageComponent,
    // InformationTechnologyPageComponent,
    // PreSchoolPageComponent,
    // TvetEducationPageComponent,
    // LanguagesPageComponent,
    // BuddhistStudiesPageComponent,
    // ComputerProgrammingPageComponent,
    // OlympiadPageComponent,
    // EconomicsPageComponent,
    // HealthPageComponent,
    // LifeSkillsPageComponent,
    ComingSoonPageComponent,
    // ResourcesPageComponent,
    // ContactPageComponent,
    // LeadershipPageComponent,
    // OurTeamPageComponent,
    // ContentSpecialistsPageComponent,
    // OurPartnersPageComponent,
    // GalleryPageComponent,
    // HelpCenterPageComponent,
    // FaqPageComponent,
    // CareersPageComponent,
    // AboutUsPageComponent,
    // SecondaryNavComponent,
    // ImpactPageComponent,
    // FormModalComponent,
    // AlbumPageComponent,
    // TvetCoursesPageComponent,
    ThousandSeparatorPipe,
    ScholarshipComponent,
    TermsComponent,
    PrivacyComponent,
    CookieComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    SwiperModule,
    LightboxModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      { path: '', component: HomePageComponent },
      { path: 'terms-and-conditions', component: TermsComponent },
      { path: 'privacy-principles', component: PrivacyComponent },
      { path: 'cookie-notice', component: CookieComponent },
      // { path: 'what-we-offer', component: WhatWeOfferPageComponent },
      // { path: 'resources', component: ResourcesPageComponent },
      // { path: 'contact', component: ContactPageComponent },
      // { path: 'leadership', component: LeadershipPageComponent },
      // { path: 'our-team', component: OurTeamPageComponent },
      // { path: 'content-specialists', component: ContentSpecialistsPageComponent },
      // { path: 'help-center', component: HelpCenterPageComponent },
      // { path: 'our-partners', component: OurPartnersPageComponent },
      // { path: 'faq', component: FaqPageComponent },
      // { path: 'careers', component: CareersPageComponent },
      // { path: 'about-us', component: AboutUsPageComponent },
      // { path: 'primary-and-secondary-education', component: PrimarySecondaryEducationPageComponent },
      // { path: 'pre-school', component: PreSchoolPageComponent },
      // { path: 'information-technology', component: InformationTechnologyPageComponent },
      // { path: 'tvet-education', component: TvetEducationPageComponent },
      // { path: 'tvet-courses', component: TvetCoursesPageComponent },
      // { path: 'languages', component: LanguagesPageComponent },
      // { path: 'buddhist-studies', component: BuddhistStudiesPageComponent },
      // { path: 'computer-programming', component: ComputerProgrammingPageComponent },
      // { path: 'olympiad-and-informatics', component: OlympiadPageComponent },
      // { path: 'economics', component: EconomicsPageComponent },
      // { path: 'health', component: HealthPageComponent },
      // { path: 'life-skills', component: LifeSkillsPageComponent },
      // { path: 'gallery', component: GalleryPageComponent },
      // { path: 'album/:id', component: AlbumPageComponent },
      // { path: 'impact', component: ImpactPageComponent },
      { path: 'coming-soon', component: ComingSoonPageComponent },
    ])
  ]
})
export class HomeModule { }
